import { CdnBucketMap } from 'core/utils/Constants';

let bucketMap = [];
for (let bucket in CdnBucketMap) {
	let domain = CdnBucketMap[bucket];
	bucketMap.push({
		bucket_domain: `//s3.amazonaws.com/${bucket}/`,
		cdn_domain: `//${domain}.cloudfront.net/`,
	});
}

export default function cdnify(s3_url=[]) {
	const total = bucketMap.length;
	for (let i = 0; i < total; i++) {
		let { bucket_domain, cdn_domain } = bucketMap[i];
		if (s3_url.indexOf(bucket_domain) !== -1) {
			return s3_url.replace(bucket_domain, cdn_domain);
		}
	}

	return s3_url;
}

export function getS3FromBucketKey(bucket, bucketKey) {
	return `//s3.amazonaws.com/${bucket}/${bucketKey}`;
}
